module.exports = __webpack_public_path__ + "static/media/elixir-label-img-1.d8136824.jpg";